import {
  AddCompetenciesToRoleDocument,
  AddCompetenciesToRoleMutation,
  RoleCompetenciesDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useAddCompetenciesToRole = () => {
  const [mutate, result] = useMutation(AddCompetenciesToRoleDocument, {
    extractorFn: (data: AddCompetenciesToRoleMutation) =>
      data.jobCatalogMutations.addCompetenciesJobcatalogRole,
    refetchQueries: [RoleCompetenciesDocument],
  })

  const addCompetenciesToRole = (id: string, competenciesIds: string[]) => {
    return mutate({ variables: { id, competenciesIds } })
  }

  return { addCompetenciesToRole, isLoading: result.loading }
}

export default useAddCompetenciesToRole
